export default __webpack_public_path__ + "59059aa18db1a69e5de6be8b84029c17.svg";